<div class="detail-page-card" data-uiid="audit-detail-finding-report-summary">
    <div class="detail-page-card-title">Linked Findings Report</div>
    <div class="detail-page-card-actions">
        @if (summaryModel) {
            @if (summaryModel.findingReportGuid) {
                @if (summaryModel.canOpen) {
                    <button
                        class="btn btn-raised"
                        (click)="openFindingReport()"
                        data-uiid="open-findings-report-button"
                    >
                        <i class="fas fa-external-link-alt"></i>
                        <span>Open Findings Report</span>
                    </button>
                }
            } @else {
                @if (summaryModel.canCreate) {
                    <button
                        class="btn btn-raised"
                        (click)="createFindingReport()"
                        data-uiid="create-findings-report-button"
                    >
                        <i class="fas fa-external-link-alt"></i>
                        <span>Create Findings Report</span>
                    </button>
                }
            }
        }
        <button
            class="btn btn-raised float-end"
            data-uiid="reload-findings-report-button"
            (click)="load()"
        >
            <i class="fas fa-sync"></i>
            <span>Reload</span>
        </button>
    </div>

    @if (isLoading) {
        <div class="fancy-loader submodule"></div>
    } @else if (summaryModel && summaryModel.findingReportGuid) {
        <div class="detail-page-card-body padded form-group-styling">
            <div class="row">
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>Report name</label>
                        <input
                            type="text"
                            [value]="summaryModel.name"
                            class="form-control form-control-sm"
                            disabled
                            inputTooltip
                            data-uiid="linked-findings-report-name-input"
                        />
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>Report type</label>
                        <input
                            type="text"
                            [value]="summaryModel.type"
                            class="form-control form-control-sm"
                            disabled
                            inputTooltip
                            data-uiid="linked-findings-report-type-input"
                        />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group">
                    <label>Scope & Objective</label>
                    <textarea
                        [value]="summaryModel.scopeAndObjective"
                        class="form-control form-control-sm"
                        disabled
                        inputTooltip
                        data-uiid="linked-findings-report-scopeAndObjective-input"
                    >
                    </textarea>
                </div>
            </div>
        </div>
    } @else {
        <div class="detail-page-card-body padded form-group-styling">
            <small data-uiid="no-linked-findings-report-txt"
                >No linked Findings Report available.</small
            >
        </div>
    }
</div>
